import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import EmailIcon from '@atlaskit/icon/glyph/email';
import { N40, N500 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';
import React from 'react';
import styled from 'styled-components';
var EmailAvatarWrapper = styled.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: ", "px;\n\n  background-color: ", ";\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n"])), function (props) {
  return props.isLozenge ? 0 : 4;
}, token('color.background.subtleNeutral.resting', N40));
export var AddOptionAvatar = function AddOptionAvatar(_ref) {
  var isLozenge = _ref.isLozenge,
      label = _ref.label;
  return /*#__PURE__*/React.createElement(EmailAvatarWrapper, {
    isLozenge: isLozenge
  }, /*#__PURE__*/React.createElement(EmailIcon, {
    label: label,
    size: isLozenge ? 'small' : 'medium',
    primaryColor: token('color.text.mediumEmphasis', N500)
  }));
};